import React from "react";

export default class CartItemBox extends React.Component {
  render() {
    const { children } = this.props;
    return (
      <div className="w-full px-4 shadow-blur-sm rounded mb-2 bg-white">
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/CartItemBox/CartItemBox.js